module.exports = __webpack_public_path__ + "catalog/holes/panic-door/panicDoor.png";